import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { VaultGate } from "@/features/vault/components/vault-gate";
import { OrgVaultsPage } from "@/features/vault/components/org-vaults-page";

/**
 * ORGANIZATION vaults (zero-knowledge multi-user). Behind the gate:
 * opening the vault key requires the user private key in memory.
 */
function OrgVaultsRoutePage() {
  return (
    <VaultGate>
      <OrgVaultsPage />
    </VaultGate>
  );
}

export const orgVaultsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/org-vaults",
  component: OrgVaultsRoutePage,
});
